import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { Avatar, ExternalLink } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { resolveNextViteImage } from '@infl-ts/util-resolve-next-vite-image';
import { pluralize } from '@infl-ts/util-string-pluralize';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Box, Button, Card, Dialog, DialogActions, DialogTitle, Divider, styled, TextField, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextTruncate from 'react-text-truncate';
import inflLogo from './influitive-logo.png';
import { validateCharCount } from './share-modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var DEFAULT_MAX_LENGTH = 280;
var StyledImage = styled('img')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  object-fit: contain;\n"])));
var LinkCard = styled(ExternalLink)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &:hover {\n    text-decoration: none;\n\n    .description-section {\n      background-color: ", ";\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.secondary.background;
});

var PreviewWrapper = function PreviewWrapper(_ref2) {
  var url = _ref2.url,
      previewTitle = _ref2.previewTitle,
      children = _ref2.children;
  return url ? /*#__PURE__*/_jsx(LinkCard, {
    sx: {
      display: 'block',
      borderRadius: 4,
      overflow: 'hidden',
      border: function border(t) {
        return "1px solid ".concat(t.palette.secondary.dark);
      },
      mt: 1
    },
    href: url !== null && url !== void 0 ? url : '#',
    rel: "noreferrer noopener",
    target: "_blank",
    title: previewTitle ? "Visit ".concat(previewTitle) : '',
    children: children
  }) : /*#__PURE__*/_jsx(Box, {
    sx: {
      borderRadius: 4,
      mt: 1
    },
    children: children
  });
};

var TwitterModal = function TwitterModal(_ref3) {
  var message = _ref3.message,
      previewDescription = _ref3.previewDescription,
      previewImageUrl = _ref3.previewImageUrl,
      previewTitle = _ref3.previewTitle,
      minimumCharacters = _ref3.minimumCharacters,
      url = _ref3.url,
      _onClose = _ref3.onClose,
      onShare = _ref3.onShare,
      sharing = _ref3.sharing;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isTruncated = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      setTruncated = _useToggle2$.on,
      clearTruncated = _useToggle2$.off;

  var _useState = useState(message),
      internalMessage = _useState[0],
      setInternalMessage = _useState[1];

  var _useToggle3 = useToggle(),
      _useToggle4 = _slicedToArray(_useToggle3, 2),
      isEditMode = _useToggle4[0],
      setEditMode = _useToggle4[1].on;

  var _useToggle5 = useToggle(),
      _useToggle6 = _slicedToArray(_useToggle5, 2),
      minCharError = _useToggle6[0],
      _useToggle6$ = _useToggle6[1],
      setCharError = _useToggle6$.on,
      removeCharError = _useToggle6$.off;

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isMessageValid = validateCharCount(minimumCharacters); // includes actual chars for url and 3 chars prepended

  var maxLength = url ? DEFAULT_MAX_LENGTH - 26 : DEFAULT_MAX_LENGTH;
  useEffect(function () {
    internalMessage.length >= maxLength ? setTruncated() : clearTruncated();
    setInternalMessage(internalMessage.slice(0, maxLength));
  }, [internalMessage, maxLength, clearTruncated, setTruncated]);
  return /*#__PURE__*/_jsxs(Dialog, {
    maxWidth: "md",
    fullWidth: true,
    open: true,
    onClose: function onClose(_, reason) {
      return reason !== 'backdropClick' && _onClose();
    },
    "aria-labelledby": "Share on Twitter",
    "data-element": "Dialog",
    "data-component": "TwitterModal",
    "data-source-file": "twitter-modal.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pr: 4,
        pl: 2
      },
      "data-element": "Box",
      "data-component": "TwitterModal",
      "data-source-file": "twitter-modal.tsx",
      children: [/*#__PURE__*/_jsx(DialogTitle, {
        sx: {
          fontSize: function fontSize(t) {
            return t.typography.h3.fontSize;
          },
          overflowWrap: 'anywhere'
        },
        "data-element": "DialogTitle",
        "data-component": "TwitterModal",
        "data-source-file": "twitter-modal.tsx",
        children: t('Share on Twitter')
      }), /*#__PURE__*/_jsx(CloseIcon, {
        sx: {
          cursor: 'pointer'
        },
        onClick: _onClose,
        "data-element": "CloseIcon",
        "data-source-file": "twitter-modal.tsx"
      })]
    }), isTruncated && /*#__PURE__*/_jsx(Alert, {
      severity: "warning",
      children: t('textTruncated', {
        count: maxLength
      })
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        mx: 4,
        my: 2
      },
      "data-element": "Box",
      "data-source-file": "twitter-modal.tsx",
      children: /*#__PURE__*/_jsx(Card, {
        sx: {
          p: 2
        },
        "data-element": "Card",
        "data-source-file": "twitter-modal.tsx",
        children: /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            gap: 1
          },
          "data-element": "Box",
          "data-source-file": "twitter-modal.tsx",
          children: [/*#__PURE__*/_jsx(Avatar, {
            size: isMobile ? 'small' : 'medium',
            disabledPopover: true,
            member: {
              id: '0',
              name: 'Unknown'
            },
            "data-element": "Avatar",
            "data-source-file": "twitter-modal.tsx"
          }), /*#__PURE__*/_jsxs(Box, {
            sx: {
              width: 1
            },
            "data-element": "Box",
            "data-source-file": "twitter-modal.tsx",
            children: [/*#__PURE__*/_jsxs(Box, {
              sx: {
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: isMobile ? 'column' : 'row'
              },
              "data-element": "Box",
              "data-source-file": "twitter-modal.tsx",
              children: [/*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(Typography, {
                  component: "span",
                  variant: "h4",
                  "data-element": "Typography",
                  "data-source-file": "twitter-modal.tsx",
                  children: t('Your name')
                }), ' ', /*#__PURE__*/_jsxs(Typography, {
                  sx: {
                    overflowWrap: 'anywhere'
                  },
                  component: "span",
                  variant: isMobile ? 'body2' : 'body1',
                  "data-element": "Typography",
                  "data-source-file": "twitter-modal.tsx",
                  children: [t('@yourTwitterHandle'), " \xB7 1h"]
                })]
              }), isEditMode && /*#__PURE__*/_jsx(Typography, {
                variant: isMobile ? 'body2' : 'body1',
                color: minCharError ? 'error' : '',
                sx: {
                  alignSelf: 'flex-end'
                },
                children: t("{{messageLength}} ".concat(pluralize('character', 'characters', internalMessage.length)), {
                  messageLength: internalMessage.length
                })
              })]
            }), isEditMode ? /*#__PURE__*/_jsx(TextField, {
              multiline: true,
              autoFocus: true,
              error: minCharError,
              value: internalMessage,
              onChange: function onChange(e) {
                if (minCharError && isMessageValid(e.target.value)) removeCharError();
                setInternalMessage(e.target.value);
              },
              sx: {
                width: 1,
                mt: 1
              }
            }) : /*#__PURE__*/_jsx(Typography, {
              sx: {
                overflowWrap: 'anywhere'
              },
              children: internalMessage
            }), /*#__PURE__*/_jsxs(PreviewWrapper, {
              url: url,
              previewTitle: previewTitle,
              "data-element": "PreviewWrapper",
              "data-source-file": "twitter-modal.tsx",
              children: [url || previewImageUrl ? /*#__PURE__*/_jsx(StyledImage, {
                src: previewImageUrl || resolveNextViteImage(inflLogo)
              }) : null, url && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Box, {
                  sx: {
                    p: 2,
                    transition: 'background-color 0.2s'
                  },
                  className: "description-section",
                  children: [/*#__PURE__*/_jsx(Typography, {
                    component: "div",
                    sx: {
                      overflow: 'hidden',
                      overflowWrap: 'anywhere'
                    },
                    color: "textSecondary",
                    children: /*#__PURE__*/_jsx(TextTruncate, {
                      line: 1,
                      truncateText: "...",
                      text: url
                    })
                  }), previewTitle && /*#__PURE__*/_jsx(Typography, {
                    component: "div",
                    sx: {
                      overflow: 'hidden',
                      overflowWrap: 'anywhere'
                    },
                    variant: "h4",
                    color: "textPrimary",
                    children: /*#__PURE__*/_jsx(TextTruncate, {
                      line: 1,
                      truncateText: "...",
                      text: previewTitle
                    })
                  }), previewDescription && /*#__PURE__*/_jsx(Typography, {
                    component: "div",
                    sx: {
                      overflow: 'hidden',
                      overflowWrap: 'anywhere'
                    },
                    variant: "body2",
                    color: "textSecondary",
                    children: /*#__PURE__*/_jsx(TextTruncate, {
                      line: 2,
                      truncateText: "...",
                      text: previewDescription
                    })
                  })]
                })]
              })]
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsxs(DialogActions, {
      sx: {
        mr: 3,
        mb: 2
      },
      "data-element": "DialogActions",
      "data-source-file": "twitter-modal.tsx",
      children: [!isEditMode && /*#__PURE__*/_jsx(Button, {
        sx: {
          mr: 1
        },
        variant: "outlined",
        onClick: setEditMode,
        children: t('Edit')
      }), /*#__PURE__*/_jsx(LoadingButton, {
        loading: sharing,
        loadingIndicator: t('Posting...'),
        variant: "contained",
        onClick: function onClick() {
          return isMessageValid(internalMessage) ? onShare(internalMessage) : setCharError();
        },
        "data-element": "LoadingButton",
        "data-source-file": "twitter-modal.tsx",
        children: t('Post')
      })]
    })]
  });
};

export default TwitterModal;